import { render, staticRenderFns } from "./V2BasicInformation.vue?vue&type=template&id=a7a7e52e&scoped=true&"
import script from "./V2BasicInformation.vue?vue&type=script&lang=js&"
export * from "./V2BasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./V2BasicInformation.vue?vue&type=style&index=0&id=a7a7e52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a7e52e",
  null
  
)

export default component.exports